module.exports = __webpack_public_path__ + "img/trive.bd9d5588.webp";